import { Plugin } from 'tiptap';
import { Image as TipTapImage } from 'tiptap-extensions';

import ImageNode from '@/components/editor/nodes/ImageNode.vue';

export default class Image extends TipTapImage {
  get view() {
    return ImageNode;
  }

  get schema() {
    return {
      inline: false,
      attrs: {
        type: {},
        uuid: {
          default: null,
        },
        src: {
          default: null,
        },
        alt: {
          default: null,
        },
        title: {
          default: null,
        },
      },
      group: 'block',
      draggable: true,
      parseDOM: [
        {
          tag: 'img[src]',
          getAttrs: dom => ({
            type: 'remote',
            src: dom.getAttribute('src'),
            title: dom.getAttribute('title'),
            alt: dom.getAttribute('alt'),
          }),
        },
      ],
      toDOM: node => [
        'img',
        {
          src: node.attrs.type === 'local' ? `{{ images.${node.attrs.uuid} }}` : node.attrs.src,
          alt: node.attrs.alt,
          title: node.attrs.title,
        },
      ],
    };
  }

  get plugins() {
    const { store } = this.options;
    return [
      new Plugin({
        props: {
          handleDOMEvents: {
            drop(view, event) {
              const hasFiles = event.dataTransfer
                && event.dataTransfer.files
                && event.dataTransfer.files.length;

              if (!hasFiles) {
                return;
              }

              const images = Array
                .from(event.dataTransfer.files)
                .filter(file => (/image/i).test(file.type));

              if (images.length === 0) {
                return;
              }

              event.preventDefault();

              const { schema } = view.state;
              const coordinates = view.posAtCoords({ left: event.clientX, top: event.clientY });

              images.forEach(image => {
                const reader = new FileReader();

                reader.onload = async readerEvent => {
                  const image = await store.dispatch('images/create', { data: readerEvent.target.result });
                  const node = schema.nodes.image.create({
                    type: 'local',
                    uuid: image.uuid,
                  });
                  const transaction = view.state.tr.insert(coordinates.pos, node);
                  view.dispatch(transaction);
                };
                reader.readAsDataURL(image);
              });
            },
          },
        },
      }),
    ];
  }
}
